export const heuresConstants = {
    HEURES_FETCH_REQUEST: "HEURES_FETCH_REQUEST",
    HEURES_FETCH_SUCCESS: "HEURES_FETCH_SUCCESS",
    HEURES_FETCH_FAILURE: "HEURES_FETCH_FAILURE",

    FEUILLEDETEMPS_UPDATE_REQUEST: "FEUILLEDETEMPS_UPDATE_REQUEST",
    FEUILLEDETEMPS_UPDATE_SUCCESS: "FEUILLEDETEMPS_UPDATE_SUCCESS",
    FEUILLEDETEMPS_UPDATE_FAILURE: "FEUILLEDETEMPS_UPDATE_FAILURE",

    FICHE_CHANTIER_FETCH_REQUEST: "FICHE_CHANTIER_FETCH_REQUEST",
    FICHE_CHANTIER_FETCH_SUCCESS: "FICHE_CHANTIER_FETCH_SUCCESS",
    FICHE_CHANTIER_FETCH_FAILURE: "FICHE_CHANTIER_FETCH_FAILURE",

    EXPORT_SUIVI_HEURES_REQUEST: "EXPORT_SUIVI_HEURES_REQUEST",
    EXPORT_SUIVI_HEURES_SUCCESS: "EXPORT_SUIVI_HEURES_SUCCESS",
    EXPORT_SUIVI_HEURES_FAILURE: "EXPORT_SUIVI_HEURES_FAILURE",

    PERIODE_PAIES_FETCH_REQUEST: "PERIODE_PAIES_FETCH_REQUEST",
    PERIODE_PAIES_FETCH_SUCCESS: "PERIODE_PAIES_FETCH_SUCCESS",
    PERIODE_PAIES_FETCH_FAILURE: "PERIODE_PAIES_FETCH_FAILURE",

    PERIODE_PAIES_FETCH_ONE_REQUEST: "PERIODE_PAIES_FETCH_ONE_REQUEST",
    PERIODE_PAIES_FETCH_ONE_SUCCESS: "PERIODE_PAIES_FETCH_ONE_SUCCESS",
    PERIODE_PAIES_FETCH_ONE_FAILURE: "PERIODE_PAIES_FETCH_ONE_FAILURE",

    PERIODE_PAIES_CREATE_REQUEST: "PERIODE_PAIES_CREATE_REQUEST",
    PERIODE_PAIES_CREATE_SUCCESS: "PERIODE_PAIES_CREATE_SUCCESS",
    PERIODE_PAIES_CREATE_FAILURE: "PERIODE_PAIES_CREATE_FAILURE",

    PERIODE_PAIES_UPDATE_REQUEST: "PERIODE_PAIES_UPDATE_REQUEST",
    PERIODE_PAIES_UPDATE_SUCCESS: "PERIODE_PAIES_UPDATE_SUCCESS",
    PERIODE_PAIES_UPDATE_FAILURE: "PERIODE_PAIES_UPDATE_FAILURE",

    PERIODE_PAIES_DELETE_REQUEST: "PERIODE_PAIES_DELETE_REQUEST",
    PERIODE_PAIES_DELETE_SUCCESS: "PERIODE_PAIES_DELETE_SUCCESS",
    PERIODE_PAIES_DELETE_FAILURE: "PERIODE_PAIES_DELETE_FAILURE",

    POSTE_CREATE_REQUEST: "POSTE_CREATE_REQUEST",
    POSTE_CREATE_SUCCESS: "POSTE_CREATE_SUCCESS",
    POSTE_CREATE_FAILURE: "POSTE_CREATE_FAILURE",

    FETCH_EQUIPAGE_DETAIL_REQUEST: "FETCH_EQUIPAGE_DETAIL_REQUEST",
    FETCH_EQUIPAGE_DETAIL_SUCCESS: "FETCH_EQUIPAGE_DETAIL_SUCCESS",
    FETCH_EQUIPAGE_DETAIL_FAILURE: "FETCH_EQUIPAGE_DETAIL_FAILURE",

    FEUILLEDETEMPS_CREATE_EMPTY_REQUEST: "FEUILLEDETEMPS_CREATE_EMPTY_REQUEST",
    FEUILLEDETEMPS_CREATE_EMPTY_SUCCESS: "FEUILLEDETEMPS_CREATE_EMPTY_SUCCESS",
    FEUILLEDETEMPS_CREATE_EMPTY_FAILURE: "FEUILLEDETEMPS_CREATE_EMPTY_FAILURE",

    HEURES_CLEAR_REQUEST: "HEURES_CLEAR_REQUEST",

    FEUILLES_TEMPS_HEBDO_FETCH_REQUEST: "FEUILLES_TEMPS_HEBDO_FETCH_REQUEST",
    FEUILLES_TEMPS_HEBDO_FETCH_SUCCESS: "FEUILLES_TEMPS_HEBDO_FETCH_SUCCESS",
    FEUILLES_TEMPS_HEBDO_FETCH_FAILURE: "FEUILLES_TEMPS_HEBDO_FETCH_FAILURE",

    POSTE_OPERATEUR_UPDATE_REQUEST: "POSTE_OPERATEUR_UPDATE_REQUEST",
    POSTE_OPERATEUR_UPDATE_SUCCESS: "POSTE_OPERATEUR_UPDATE_SUCCESS",
    POSTE_OPERATEUR_UPDATE_FAILURE: "POSTE_OPERATEUR_UPDATE_FAILURE",

    ALERTE_RH_UPDATE_REQUEST: "ALERTE_RH_UPDATE_REQUEST",
    ALERTE_RH_UPDATE_SUCCESS: "ALERTE_RH_UPDATE_SUCCESS",
    ALERTE_RH_UPDATE_FAILURE: "ALERTE_RH_UPDATE_FAILURE",

    HEURES_HEBDO_RH_FETCH_REQUEST: "HEURES_HEBDO_RH_FETCH_REQUEST",
    HEURES_HEBDO_RH_FETCH_SUCCESS: "HEURES_HEBDO_RH_FETCH_SUCCESS",
    HEURES_HEBDO_RH_FETCH_FAILURE: "HEURES_HEBDO_RH_FETCH_FAILURE",

    HEURES_HEBDO_RH_VALIDATE_OPTIMISTIC: "HEURES_HEBDO_RH_VALIDATE_OPTIMISTIC",
    HEURES_HEBDO_RH_DEVALIDATE_OPTIMISTIC: "HEURES_HEBDO_RH_DEVALIDATE_OPTIMISTIC",
    HEURES_HEBDO_RH_TOGGLE_DEPLACEMENT_OPTIMISTIC: "HEURES_HEBDO_RH_TOGGLE_DEPLACEMENT_OPTIMISTIC",
};
